@if(label()){
  <label class="f-small text-neutral-700 mb-1" for="manager">{{label()}}</label>
}
<app-customised-single-select [controls]="{control:control()}" [controlName]="'control'" id="manager"
 [options]="options()" [showAvatar]="true"
 placeholder="Select a user" displayName="user" [submitted]="submitted()"
 ></app-customised-single-select>
